// import IntegrationService from '@/services/integration/IntegrationService'
import service from '@/services/integration/ifood/IfoodService'
import { verifyOrderTiming } from '@/utils/utils'

export const ifoodModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    synchronizationLog: [],
    pollingList: [],
    orderList: [],
    merchantsList: [],
    order: {},
    orderPolling: null,
    eventPolling: null,
    orderPollingTest: {
      id: '63895716-37c3-4372-afd0-3240bfef708d',
      orderTiming: 'SCHEDULED',
      schedule: {
        deliveryDateTimeStart: '2021-02-09T21:05:29Z',
        deliveryDateTimeEnd: '2021-02-09T18:19:50Z',
      },
      orderType: 'DELIVERY',
      salesChannel: 'IFOOD',
      delivery: {
        mode: 'ECONOMIC',
        deliveredBy: 'IFOOD',
        deliveryDateTime: '2021-02-09T18:10:32Z',
        deliveryAddress: {
          streetName: 'Example',
          streetNumber: '1234',
          formattedAddress: 'Example St., 1234, Apt. 1234',
          neighborhood: 'Examplehood',
          complement: 'Apt. 1234',
          reference: 'perto da praça',
          postalCode: '12345678',
          city: 'Example City',
          state: 'Example State',
          country: 'BR',
          coordinates: {
            latitude: -2.1059418202311173e141,
            longitude: -49545.71,
          },
        },
      },
      displayId: 'XPTO',
      createdAt: '2021-02-16T18:10:27Z',
      preparationStartDateTime: '2021-02-09T20:15:13Z',
      merchant: {
        id: 'c54bb20a-bce0-4e38-bd4a-fe5f0a7b6b5a',
        name: 'Example Merchant',
      },
      customer: {
        id: '22587f70-60b4-423c-8cd2-27d288f47f99',
        name: 'Example Customer',
        documentNumber: '123456789',
        phone: {
          number: '123456789',
          localizer: '12345678',
          localizerExpiration: '2021-02-09T18:11:07Z',
        },
        ordersCountOnMerchant: null,
      },
      items: [
        {
          index: 0,
          id: 'f1e48636-4bf0-4656-bce8-0e2214fcd3d4',
          name: 'Example Item',
          imageUrl:
            'https://static-images.ifood.com.br/image/upload/t_high/pratos/4c714577-fe5d-4d31-9531-f9ebb7f89249/202104071957_0mfD_.jpeg',
          externalCode: 'ex01',
          ean: '12345678910',
          unit: 'G',
          quantity: 12,
          unitPrice: 0.12,
          addition: 0,
          price: 1.44,
          optionsPrice: 1.69,
          totalPrice: 3.13,
          observations: 'This is an example item.',
          options: [
            {
              index: 0,
              id: 'acea6ac1-f595-4a6b-af00-cc2f1fa0886a',
              name: 'Example Option',
              externalCode: 'ex02',
              ean: '12345678911',
              unit: 'UN',
              quantity: 13,
              unitPrice: 0.13,
              addition: 0,
              price: 1.69,
            },
          ],
        },
      ],
      benefits: [
        {
          value: 1.0,
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 0.5,
            },
            {
              name: 'MERCHANT',
              value: 0.5,
            },
          ],
          target: 'CART',
        },
        {
          value: 0.5,
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 0.5,
            },
            {
              name: 'MERCHANT',
              value: 0,
            },
          ],
          target: 'ITEM',
          targetId: '1',
        },
        {
          value: 0.49,
          sponsorshipValues: [
            {
              name: 'IFOOD',
              value: 0,
            },
            {
              name: 'MERCHANT',
              value: 0.49,
            },
          ],
          target: 'DELIVERY_FEE',
        },
      ],
      additionalFees: [
        {
          type: 'SMALL_ORDER_FEE',
          value: 1.0,
        },
      ],
      total: {
        subTotal: 3.13,
        deliveryFee: 5.99,
        additionalFees: 1,
        benefits: 1.99,
        orderAmount: 8.13,
      },
      payments: {
        prepaid: 2.13,
        pending: 5,
        methods: [
          {
            value: 5,
            currency: 'BRL',
            method: 'CASH',
            type: 'OFFLINE',
            prepaid: false,
          },
          {
            value: 2.13,
            currency: 'BRL',
            method: 'MEAL_VOUCHER',
            type: 'ONLINE',
            prepaid: true,
          },
        ],
      },
      picking: {
        picker: 'DRIVER_SHOPPER',
        replacementOptions: 'STORE_REMOVE_ITEMS',
      },
      test: false,
    },
    statusMerchant: {},
    optionsToCancelOrder: null,
    defaultOptionsToCancelOrder: [
      { id: 501, title: 'PROBLEMAS DE SISTEMA' },
      { id: 502, title: 'PEDIDO EM DUPLICIDADE' },
      { id: 503, title: 'ITEM INDISPONÍVEL' },
      { id: 504, title: 'RESTAURANTE SEM MOTOBOY' },
      { id: 505, title: 'CARDÁPIO DESATUALIZADO' },
      { id: 506, title: 'PEDIDO FORA DA ÁREA DE ENTREGA' },
      { id: 507, title: 'CLIENTE GOLPISTA / TROTE' },
      { id: 508, title: 'FORA DO HORÁRIO DO DELIVERY' },
      { id: 509, title: 'DIFICULDADES INTERNAS DO RESTAURANTE' },
      { id: 511, title: 'ÁREA DE RISCO' },
      { id: 512, title: 'RESTAURANTE ABRIRÁ MAIS TARDE' },
      { id: 513, title: 'RESTAURANTE FECHOU MAIS CEDO' },
    ],
    optionsTimeToClose: [
      { id: 1, title: '15 minutos', value: 15 },
      { id: 2, title: '30 minutos', value: 30 },
      { id: 3, title: '1 hora', value: 60 },
      { id: 4, title: '3 horas', value: 180 },
      { id: 5, title: '6 horas', value: 360 },
      { id: 6, title: '12 horas', value: 720 },
      { id: 7, title: '24 minutos', value: 1440 },
    ],
    optionsReasonToClose: [
      { id: 1, title: 'Muitos Pedidos' },
      { id: 2, title: 'Problema na cozinha' },
      { id: 3, title: 'Falta de entregador' },
      { id: 4, title: 'Outro' },
    ],
    itemsTipoPrevisao: [
      { title: 'Retira', value: 'TAKEOUT', icon: 'mdi-store' },
      { title: 'Entrega', value: 'DELIVERY', icon: 'mdi-moped-outline' },
      { title: 'Entrega', value: 'INDOOR', icon: 'mdi-moped-outline' },
    ],
    canceledCodes: ['CAN', 'CAR', 'CCR', 'CCA', 'CCD'],
  },
  mutations: {
    SET_ORDER_LIST(state, payload) {
      state.orderList = payload.data ?? payload
    },
    SET_MERCHANT_LIST(state, payload) {
      state.merchantsList = payload
    },
    SET_POLLING_LIST(state, payload) {
      /* LISTA ORIGINAL BACKEND */
      const canceled = payload.original.filter(
        (v) => state.canceledCodes.lastIndexOf(v.CODE) != -1
      )
      const normal = payload.original.filter(
        (v) => state.canceledCodes.lastIndexOf(v.CODE) == -1
      )
      state.pollingList = [...normal, ...canceled]
    },
    SET_ORDER(state, payload) {
      state.order = payload.data ?? payload
    },
    SET_ORDER_POLLING(state, payload) {
      state.orderPolling = payload ? Object.assign({}, payload) : payload
    },
    SET_EVENT_POLLING(state, payload) {
      state.eventPolling = payload
    },
    SET_STATUS_MERCHANT(state, payload) {
      state.statusMerchant = payload
    },
    UPDATE_LIST(state, payload) {
      state.pollingList = state.pollingList.map((ev) => {
        if (ev.ID == payload.id) {
          ev.CODE = payload.code
          ev.FULLCODE = payload.fullCode
        }
        return ev
      })
    },
    SET_SYNCHRONIZATION_LOG(state, payload) {
      state.synchronizationLog = payload
    },

    SET_CANCELLATION_REASONS(state, payload) {
      state.optionsToCancelOrder = payload.map((option) => {
        return {
          id: option.cancelCodeId,
          title: option.description,
        }
      })
    },
  },
  actions: {
    async setPollingList({ commit }, payload) {
      await commit('SET_POLLING_LIST', payload)
    },
    async generateContract() {
      const retorno = await service.getContract()
      return retorno
    },
    async getOrdersIntegration({ commit }, payload) {
      let response = await service.getOrders(payload)
      commit('SET_ORDER_LIST', response)
    },
    async createIntegration() {
      return await service.createIntegration()
    },
    async getOrderIntegration({ commit }, payload) {
      let response = await service.getOrderIntegration(payload)
      commit('SET_ORDER_POLLING', response)
      return response
    },
    async getOrderCancellationReasons({ commit }, payload) {
      const response = await service.getOrderCancellationReasons(payload)

      await commit('SET_CANCELLATION_REASONS', response.data)

      return response.data
    },
    setEventPolling({ commit }, payload) {
      commit('SET_EVENT_POLLING', payload)
      if (payload.order) commit('SET_ORDER_POLLING', payload.order)
    },
    setOrderPolling({ commit }, payload) {
      if (payload && payload.order) {
        commit('SET_EVENT_POLLING', payload)
        commit('SET_ORDER_POLLING', payload.order)
      } else {
        commit('SET_ORDER_POLLING', payload)
      }
    },
    updateList({ commit }, payload) {
      const { action, event } = payload
      let updatedEvent = {
        id: event.id,
        code: '',
        fullCode: '',
      }
      switch (action) {
        case 'confirmOrder':
        case 'startPreparationOrder':
          updatedEvent.code = 'CFM'
          updatedEvent.fullCode = 'CONFIRMED'
          break
        case 'readyToPickupOrder':
          updatedEvent.code = 'RTP'
          updatedEvent.fullCode = 'READY_TO_PICKUP'
          break
        case 'dispatchOrder':
          updatedEvent.code = 'DSP'
          updatedEvent.fullCode = 'DISPATCHED'
          break
        case 'cancelOrder':
          updatedEvent.code = 'CAR'
          updatedEvent.fullCode = 'CANCELLATION_REQUESTED'
          break

        default:
          updatedEvent.code = event.code
          updatedEvent.fullCode = event.fullCode
          break
      }

      commit('UPDATE_LIST', updatedEvent)
    },

    async getSynchronizationLog({ commit }, payload) {
      let response = await service.getSynchronizationLog(payload)
      commit('SET_SYNCHRONIZATION_LOG', response.data)
    },

    setEmptySynchronizationLog({ commit }, payload) {
      commit('SET_SYNCHRONIZATION_LOG', payload)
    },

    // integration routes
    setStatusWebsocket({ commit }, payload) {
      commit('SET_STATUS_MERCHANT', payload)
    },

    async getStatusMerchant({ commit }) {
      let response = await service.getStatusMerchant()
      commit('SET_STATUS_MERCHANT', response)
    },

    async getMerchants({ commit }) {
      let response = await service.getMerchants()
      commit('SET_MERCHANT_LIST', response)
    },

    // interrupcoes
    async createInterruption({ dispatch }, payload) {
      await service.createInterruption(payload)
      await new Promise((resolve) => {
        setTimeout(resolve, 10000)
      })

      await dispatch('getStatusMerchant')

      return true
    },
    async deleteInterruption({ dispatch }, payload) {
      await service.deleteInterruption(payload)
      await new Promise((resolve) => {
        setTimeout(resolve, 10000)
      })

      await dispatch('getStatusMerchant')

      return true
    },

    // rotas de acao Pedidos

    async confirmOrder(context, payload) {
      return await service.confirmOrder(payload)
    },
    async startPreparationOrder(context, payload) {
      return await service.startPreparationOrder(payload)
    },
    async readyToPickupOrder(context, payload) {
      return await service.readyToPickupOrder(payload)
    },
    async dispatchOrder(context, payload) {
      return await service.dispatchOrder(payload)
    },
    async cancelOrder(context, payload) {
      return await service.cancelOrder(payload)
    },

    async acceptCancellation(context, payload) {
      return await service.acceptCancellation(payload)
    },
    async denyCancellation(context, payload) {
      return await service.denyCancellation(payload)
    },
  },
  getters: {
    getOrders: (state) => {
      return state.orderList
    },
    indexedPollingList: (state) => {
      return state.pollingList.map((v, index) => ({
        index: index,
        id: v.ID,
        code: v.CODE,
        fullCode: v.FULLCODE,
        orderId: v.ORDERID,
        merchantId: v.MERCHANTID,
        createdAt: v.CREATEDAT,
        order: JSON.parse(v.ORDEROBJ),
        metadata: v.METADATA ? JSON.parse(v.METADATA) : null,
        isWait: verifyOrderTiming(JSON.parse(v.ORDEROBJ)),
      }))
    },

    nowPollingList: (state, getters) => {
      let indexedList = getters.indexedPollingList

      const list = indexedList.filter((event) => {
        if (
          event.order.orderTiming != 'SCHEDULED' ||
          (event.order.orderTiming == 'SCHEDULED' && !event.isWait)
        )
          return event
      })

      const objectMap = list.reduce((map, object) => {
        map.set(object.orderId, object)
        return map
      }, new Map())
      // eslint-disable-next-line
      return Array.from(objectMap, ([_, value]) => value)
    },

    scheduledPollingList: (state, getters) => {
      let indexedList = getters.indexedPollingList
      const list = indexedList.filter((event) => {
        if (
          event.order.orderTiming == 'SCHEDULED' &&
          (event.code == 'PLC' || event.code == 'CAN' || event.code == 'CAR') &&
          event.isWait
        )
          return event
      })

      return list
    },
    getStatusMerchant: (state) => {
      return state.statusMerchant
    },
    getItemsTipoPrevisao: (state) => {
      return state.itemsTipoPrevisao
    },

    getSynchronizationLog: (state) => {
      return state.synchronizationLog
    },

    getOptionsToCancelOrder: (state) => {
      return state.optionsToCancelOrder?.length > 0
        ? state.optionsToCancelOrder
        : state.defaultOptionsToCancelOrder
    },
  },
}
